import { IsEnum, IsNotEmpty } from 'class-validator';
import { ServiceProviderStatus } from './service-provider.dto';

export class PatchServiceProviderStatusDto {
  @IsNotEmpty()
  @IsEnum(ServiceProviderStatus)
  status!: ServiceProviderStatus;
}
